import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SnackbarState {
    message: string;
    type: 'success' | 'error';
    open: boolean;
}

const initialState: SnackbarState = {
    message: '',
    type: 'success',
    open: false,
};

const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        showSnackbar: (
            state,
            action: PayloadAction<{ message: string; type: 'success' | 'error' }>
        ) => {
            state.message = action.payload.message;
            state.type = action.payload.type;
            state.open = true;
        },
        hideSnackbar: (state) => {
            state.open = false;
        },
    },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;